// extracted by mini-css-extract-plugin
module.exports = {"container":"a10a3f92e9--container--jd1SS","title":"a10a3f92e9--title--brTE4","text":"a10a3f92e9--text--m78Z9"};